import 'history';
import 'localforage';
import 'moment';
import 'moment/locale/fr.js';
import 'offline-plugin/runtime';
import 'react';
import 'react-dom';
import 'react-hot-loader';
import 'react-redux';
import 'react-router';
import 'react-router-redux';
import 'react-tap-event-plugin';
import 'redux';
import 'redux-form';
import 'redux-persist';
import 'redux-persist-migrate';
import 'redux-persist-transform-filter';
import 'redux-thunk';
import 'restful.js';
import 'raven-js';
import 'scroll-into-view-if-needed';

import 'react-select2-wrapper';
import 'react-slick';




// WEBPACK FOOTER //
// ./book/src/vendor.js